import React from "react";
import { connect } from "react-redux";
// import { 
// 	Table,
// 	Button,
// 	Modal,
// 	Spin,
// 	message,
// 	Row,
// 	Col,
// 	Icon,
// 	Divider,
// 	Form,
// 	Input,
// 	Select,
// 	Radio,
// 	DatePicker,
// 	InputNumber
// } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
// import newcomerTrainingService from "../../services/Training/newcomer-training-service";
import {

} from "../../actions/training-actions";


class NewcomerTraining extends ReduxComponent {




	render() {
		return (<div>新人培训</div>);
	}
}

const mapStateToProps = state => {

}

const mapDispatchToProps = {

}


export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(NewcomerTraining));






// WEBPACK FOOTER //
// ./src/routes/Training/NewcomerTraining.js